import { useEffect } from "react";
import Lenis from "lenis";
import { Navbar } from "../components/Navbar";
import { Hero } from "../components/Hero";
import { Marquee } from "../components/Marquee";
import { About, Mission, Manifesto } from "../components/Story";
import { Pillars } from "../components/Pillars";
import { Sportello, Projects, Events, Roadmap } from "../components/Programs";
import { Calendar } from "../components/Calendar";
import { News } from "../components/News";
import { NewsletterSignup } from "../components/NewsletterSignup";
import { Join, Contact, Footer } from "../components/Join";

export default function Landing() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="App grain">
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <About />
        <Mission />
        <Pillars />
        <Manifesto />
        <Sportello />
        <Projects />
        <Events />
        <Calendar />
        <News />
        <Roadmap />
        <NewsletterSignup />
        <Join />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
